<template>
  <img
    :src="settings.registration_logo"
    :alt="settings.brand_name"
    class="header-logo"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useInitStore } from '@/stores/init'

defineOptions({ name: 'Logo' })

const initStore = useInitStore()
const { settings } = storeToRefs(initStore)
</script>

<style lang="less">
.header-logo {
  width: 100%;
  padding: 32px 0;
  margin: 0 auto;
  max-width: 130px;
  background-color: #f0f0f0;
}
</style>
